// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"014f001d","389":"3f0b729f","453":"c0c381f5","455":"db37db76","977":"bd398753"}[chunkId] + ".chunk.js";
};